import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { CartService } from 'src/app/services/cart.service';
import { CashRegisterService } from 'src/app/services/cash-register.service';
import { PassesService } from 'src/app/services/passes.service';
import { faArrowRightFromBracket, faMemoCircleInfo, faBookmark } from '@fortawesome/pro-light-svg-icons';
import { faFileInvoiceDollar, faRotateLeft, faTicket, faCalendarDays, faGear } from '@fortawesome/pro-light-svg-icons';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import { filter } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { DialogSettingsComponent } from '../dialog-settings/dialog-settings.component';

@Component({
  selector: 'app-status-bar',
  templateUrl: './status-bar.component.html',
  styleUrls: ['./status-bar.component.scss']
})
export class StatusBarComponent implements OnInit {
  faCircle = faCircle;
  faArrowRightFromBracket = faArrowRightFromBracket;
  faMemoInfo = faMemoCircleInfo;
  faReport = faFileInvoiceDollar;
  faRefunds = faRotateLeft;
  faBookmark = faBookmark;
  faPasses = faTicket;
  faEvents = faCalendarDays;
  faGear = faGear;
  cash_register_name: any = '';
  cash_register_sesion_id: Number = 0;
  id_business: any;
  isPassSale: boolean = false;
  hasPasses: boolean = false;
  isReservationMode: boolean = false;

  constructor(private cashRegisterService: CashRegisterService, private cartService: CartService, private passesService: PassesService, private router: Router, private dialog: MatDialog) {
    this.cash_register_name = localStorage.getItem('cash_register_name')
    this.id_business = localStorage.getItem('id_business');

    this.cashRegisterService.checkCashRegisterStatus(this.id_business, Number(localStorage.getItem('id_cash_register'))).subscribe({
      next: (res) => {
        this.cash_register_sesion_id = res.data.id;
        localStorage.setItem('id_work_time', res.data.id);
        this.cartService.getCart().subscribe();
      }
    });
  }

  ngOnInit() {
    const initialUrl = this.router.url;
    this.isPassSale = initialUrl.startsWith('/pass-sale') || initialUrl.startsWith('/passes');
    this.isReservationMode = this.detectReservationMode(initialUrl);
    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd)
    ).subscribe((e: any) => {
      const url = e.urlAfterRedirects || e.url;
      this.isPassSale = url?.startsWith('/pass-sale') || url?.startsWith('/pass-sale-bulk') || url?.startsWith('/passes');
      this.isReservationMode = this.detectReservationMode(url);
    });

    this.passesService.getCompanyPasses().subscribe({
      next: (passes) => { this.hasPasses = passes.length > 0; },
      error: () => { this.hasPasses = false; }
    });
  }

  viewEvents() {
    this.router.navigateByUrl('/home');
  }

  private detectReservationMode(url: string): boolean {
    if (!url) return false;
    const queryIdx = url.indexOf('?');
    if (queryIdx === -1) return false;
    const params = new URLSearchParams(url.substring(queryIdx + 1));
    return !!params.get('reservationId');
  }

  // closeWorkTime() {
  //   if (localStorage.getItem('id_cash_register')) {
  //     this.cashRegisterService.closeWorkTime(Number(localStorage.getItem('id_cash_register'))).subscribe(response => {
  //       if (response) {
  //         this.cartService.clearCartState();
  //         localStorage.removeItem('id_cash_register')
  //         localStorage.removeItem('cash_register_name')
  //         let idWorkingTime = localStorage.getItem('id_work_time')
  //         localStorage.removeItem('id_work_time')
  //         this.router.navigateByUrl("/cash-register-report/" + response.id)
  //       }
  //     })
  //   }
  // }

  viewReports() {
    this.cashRegisterService.checkCashRegisterStatus(this.id_business, Number(localStorage.getItem('id_cash_register'))).subscribe({
      next: (res) => {
        this.router.navigateByUrl("/cash-register-report/" + res.data.id)
      }
    });
  }

  viewRefunds() {
    this.router.navigateByUrl("/refunds");
  }

  viewReservas() {
    this.router.navigateByUrl("/reservas");
  }

  viewPasses() {
    this.router.navigateByUrl("/passes");
  }

  openSettings() {
    this.dialog.open(DialogSettingsComponent, {
      panelClass: 'settings-dialog-panel',
      position: { top: '70px', right: '20px' }
    });
  }
}
